import {
  Box,
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  ButtonGroup,
} from "@mui/material";
import { useEffect, useState } from "react";
import { APPOINTMENT_DETAILS_LISTING_COLUMNS } from "../../utils/constant";

import { AppoinmentDetailPopUp } from "./AppointmentDetailsPopUp";
import NoDataComponent from "../../common/RecordNotFound";
import useGlobalState from "../../Context";
import { useNavigate } from "react-router-dom";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import appointmentListingService from "../../services/appointmentListingService";
import { APPOINTMENT_COFNIG_HEADER } from "../../utils/headerConstants";
import { getConfigService } from "../../services/apiService";
import {
  VendorAppointmentCancel,
  searchAppointmentsBySmartSearch,
} from "../../services/VendorAppointmentBook";
import Action from "./Action";
import CancelAppointmentPopup from "./CancelAppointmentPopup";
import SmartSearch from "../../common/SmartSearch";
import { List } from "@material-ui/icons";
import {
  getStatusColor,
  padPO,
  convertDateFromUTCString,
} from "../../utils/jsUtils";

const AppointmentListing = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalElement, setTotalElement] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [searchedRows, setSearchedRows] = useState([]);
  const [isSearchMode, setIsSearchMode] = useState(false);
  const [appointmentDetails, setAppointmentDetails] = useState({});
  const [dialogOpen, setDialogOpen] = useState(false);
  const [cancel, setCancel] = useState(false);
  const { showNotification } = useNotificationContext();
  const [cancelAppointment, setCancelAppointment] = useState(null);
  const { setLoading } = useLoading();
  const [{ userDetails }] = useGlobalState();
  const userParam = userDetails?.userParam;
  const vendorCode = userParam?.vendorCode;

  const handleClose = () => {
    setDialogOpen(false);
  };

  const handleChangeRowsPerPage = async (event) => {
    const paginationValues = {
      pageNo: 0,
      pageSize: +event.target.value,
    };
    if (!isSearchMode) {
      await handleTableChanges(paginationValues, false);
    }
    setMaxPage(0);
    setPageNo(0);
    setPageSize(event.target.value);
  };

  const handleTableChanges = async (paginationValues, isUpdate) => {
    try {
      setLoading(true);
      const requestBody = {
        vendorCode: padPO(vendorCode),
        page: paginationValues?.pageNo ?? 0,
        size: paginationValues?.pageSize ?? 10,
      };

      const appointmentListingResponse = await appointmentListingService(
        baseUrl,
        requestBody
      );
      if (appointmentListingResponse?.messageCode === 6) {
        if (isUpdate) {
          setTotalElement(appointmentListingResponse?.totalElements);
          let appointments = appointmentListingResponse.appointmentParams;
          appointments.sort((a, b) => {
            // Parse dates and compare them
            const dateA = new Date(a.appointmentDate);
            const dateB = new Date(b.appointmentDate);

            return dateB - dateA; // Compare dates in descending order
          });
          setSearchedRows([...searchedRows, ...appointments]);
        } else {
          let appointments = appointmentListingResponse.appointmentParams;
          appointments.sort((a, b) => {
            // Parse dates and compare them
            const dateA = new Date(a.appointmentDate);
            const dateB = new Date(b.appointmentDate);

            return dateB - dateA; // Compare dates in descending order
          });
          setTotalElement(appointmentListingResponse?.totalElements);
          setSearchedRows(appointments);
        }
      } else {
        showNotification(
          "Error",
          appointmentListingResponse?.message ??
            "Failed to Fetch Appointment List Data"
        );
      }
    } catch (e) {
      showNotification(
        "Error",
        e?.message ?? "Failed to Fetch Appointment List Data"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleChangePage = async (event, newPage) => {
    if (newPage > pageNo && newPage > maxPage) {
      setMaxPage(newPage);
      const paginationValues = {
        pageNo: newPage,
        pageSize: pageSize,
      };
      if (!isSearchMode) {
        await handleTableChanges(paginationValues, true);
      }
    }
    setPageNo(newPage);
  };

  const handleClickOpen = (row) => {
    setAppointmentDetails(row);
    setDialogOpen(true);
  };

  const onclickEdit = (data) => {
    checkEditConfig(data);
  };

  const cancelAppoitmentPopup = (data) => {
    checkCancelConfig(data);
  };

  const cancelAppoitment = async (remark) => {
    try {
      setLoading(true);
      const requestBody = {
        appointmentId: cancelAppointment?.appointmentId,
        status: cancelAppointment?.status,
        remark: remark,
      };
      const appointmentListingResponse = await VendorAppointmentCancel(
        baseUrl,
        requestBody
      );
      if (appointmentListingResponse?.messageCode === 6) {
        showNotification(
          "Success",
          appointmentListingResponse?.message ?? "Appointment Cancelled",
          "success"
        );
        setCancel(false);
        setCancelAppointment(null);
        const newSearchedRows = searchedRows?.map((row) => {
          if (row?.appointmentId === cancelAppointment?.appointmentId) {
            return { ...row, status: 2, statusContent: "PROCESSING" };
          } else {
            return row;
          }
        });
        setSearchedRows(newSearchedRows);
      } else {
        showNotification(
          "Error",
          appointmentListingResponse?.message ?? "Failed To Cancel Appointment"
        );
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed To Cancel Appointment");
    } finally {
      setLoading(false);
    }
  };

  const selectSearchId = (key) => {
    switch (key) {
      case "PO":
        return "po";
      case "Appointment Id":
        return "appointmentId";
      default:
        break;
    }
  };

  const onClickSearch = async (searchObject) => {
    if (searchObject?.searchValue) {
      try {
        setLoading(true);
        const requestBody = {
          searchValue: searchObject?.searchValue?.trim(),
          searchFlag: selectSearchId(searchObject?.searchWith),
          vendorCode: padPO(vendorCode),
        };
        let searchResultResponse = await searchAppointmentsBySmartSearch(
          baseUrl,
          requestBody
        );
        if (searchResultResponse?.messageCode === 6) {
          setTotalElement(searchResultResponse?.appointmentParams.length);
          setSearchedRows(searchResultResponse?.appointmentParams);
          setIsSearchMode(true);
          setMaxPage(0);
          setPageNo(0);
        } else if (searchResultResponse?.messageCode === 2) {
          showNotification(
            "Not Found",
            "No Record Found With Search Parameters"
          );
          setIsSearchMode(true);

          setTotalElement(0);
          setSearchedRows([]);
        } else {
          showNotification(
            "Error",
            searchResultResponse?.message ??
              "No Record Found With Search Parameters"
          );
        }
      } catch (err) {
        showNotification("Error", err?.message ?? "Failed To Search Value");
      } finally {
        setLoading(false);
      }
    } else {
      showNotification("Error", "Something went wrong");
    }
  };

  useEffect(() => {
    handleTableChanges({ pageNo, pageSize }, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isEditAllowed = (date) => {
    let parms = date.split(/[\.\-T\/]/);
    let yyyy = parseInt(parms[0], 10);
    let mm = parseInt(parms[1], 10);
    let dd = parseInt(parms[2], 10);

    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const firstDate = new Date(yyyy, mm - 1, dd);
    const secondDate = new Date();

    const diffDays = (firstDate - secondDate) / oneDay;

    if (diffDays >= 1) {
      return true;
    } else if (diffDays > 0) {
      return true;
    } else {
      return false;
    }
  };

  const isCancelAllowed = (date) => {
    let parms = date.split(/[\.\-T\/]/);
    let yyyy = parseInt(parms[0], 10);
    let mm = parseInt(parms[1], 10);
    let dd = parseInt(parms[2], 10);

    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const firstDate = new Date(yyyy, mm - 1, dd);
    const secondDate = new Date();

    const diffDays = (firstDate - secondDate) / oneDay;

    if (diffDays >= 1) {
      return true;
    } else if (diffDays > 0) {
      return true;
    } else {
      return false;
    }
  };

  const isEditConfigCheck = (config, data) => {
    let parms = data?.appointmentDate?.split(/[\.\-T\/]/);
    let yyyy = parseInt(parms[0], 10);
    let mm = parseInt(parms[1], 10);
    let dd = parseInt(parms[2], 10);

    const configData =
      config?.param[0]?.configs?.vendorEditAppointmentCutOffTime;
    let TimeParms = configData.split(":");
    let hour = parseInt(TimeParms[0], 10);
    let mint = parseInt(TimeParms[1], 10);
    let sec = parseInt(TimeParms[2], 10);

    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const firstDate = new Date(yyyy, mm - 1, dd);
    const secondDate = new Date();

    const diffDays = (firstDate - secondDate) / oneDay;

    if (diffDays > 1) {
      return true;
    } else if (diffDays > 0) {
      var now = new Date();
      var nowTime = new Date(
        now.getMonth() +
          1 +
          "/" +
          now.getDate() +
          "/" +
          now.getFullYear() +
          " " +
          now.getHours() +
          ":" +
          now.getMinutes()
      );
      var userTime = new Date(
        now.getMonth() +
          1 +
          "/" +
          now.getDate() +
          "/" +
          now.getFullYear() +
          " " +
          hour +
          ":" +
          mint +
          ":" +
          sec
      );
      if (nowTime.getTime() >= userTime.getTime()) {
        return false;
      } else {
        return true;
      }
    } else if (diffDays === 0) {
      return false;
    } else {
      return false;
    }
  };

  const checkEditConfig = async (data) => {
    try {
      setLoading(true);
      const configRes = await getAppointmentConfig(
        data?.fcCode,
        data?.vendorCode
      );
      if (configRes?.messageCode === 6) {
        if (isEditConfigCheck(configRes, data)) {
          navigate("/edit-book-appointment", { state: data });
        } else {
          showNotification(
            "Warning",
            "Any modification is allowed only before " +
              formatTime(
                configRes?.param[0]?.configs?.vendorEditAppointmentCutOffTime
              ) +
              " for next day appointment",
            "warning"
          );
          handleTableChanges({ pageNo, pageSize }, false);
        }
      } else {
        showNotification("Error", configRes?.message ?? "Data fetched");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Error fetching config data");
    } finally {
      setLoading(false);
    }
  };

  const isCancelConfigCheck = (config, data) => {
    let parms = data?.appointmentDate?.split(/[\.\-T\/]/);
    let yyyy = parseInt(parms[0], 10);
    let mm = parseInt(parms[1], 10);
    let dd = parseInt(parms[2], 10);

    const configData =
      config?.param[0]?.configs?.vendorCancelAppointmentCutOffTime;
    let TimeParms = configData.split(":");
    let hour = parseInt(TimeParms[0], 10);
    let mint = parseInt(TimeParms[1], 10);
    let sec = parseInt(TimeParms[2], 10);

    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const firstDate = new Date(yyyy, mm - 1, dd);
    const secondDate = new Date();

    const diffDays = ((firstDate - secondDate) / oneDay);

    if (diffDays > 1) {
      return true;
    } else if (diffDays > 0) {
      var now = new Date();
      var nowTime = new Date(
        now.getMonth() +
          1 +
          "/" +
          now.getDate() +
          "/" +
          now.getFullYear() +
          " " +
          now.getHours() +
          ":" +
          now.getMinutes()
      );
      var userTime = new Date(
        now.getMonth() +
          1 +
          "/" +
          now.getDate() +
          "/" +
          now.getFullYear() +
          " " +
          hour +
          ":" +
          mint +
          ":" +
          sec
      );
      if (nowTime.getTime() >= userTime.getTime()) {
        return false;
      } else {
        return true;
      }
    } else if (diffDays === 0) {
      return false;
    } else {
      return false;
    }
  };

  const checkCancelConfig = async (data) => {
    try {
      setLoading(true);
      const configRes = await getAppointmentConfig(
        data?.fcCode,
        data?.vendorCode
      );
      if (configRes?.messageCode === 6) {
        if (isCancelConfigCheck(configRes, data)) {
          setCancel(true);
          setCancelAppointment(data);
        } else {
          showNotification(
            "Warning",
            "Cancellation is allowed only before " +
              formatTime(
                configRes?.param[0]?.configs?.vendorCancelAppointmentCutOffTime
              ) +
              " for next day appointment",
            "warning"
          );
        }
      } else {
        showNotification("Error", configRes?.message ?? "Data fetched");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Error fetching config data");
    } finally {
      setLoading(false);
    }
  };

  const getAppointmentConfig = async (siteCode, vendorCode) => {
    const param = {
      siteCode: siteCode,
      vendorCode: vendorCode,
    };
    const requestBody = {
      params: [param],
    };
    const configResponse = await getConfigService(
      requestBody,
      APPOINTMENT_COFNIG_HEADER
    );
    return configResponse;
  };

  const formatTime = (timeString) => {
    if (!timeString) return "-"; // Return a hyphen if timeString is null or undefined

    const [hours, minutes] = timeString.split(":");
    return `${hours.padStart(2, "0")}:${minutes.padStart(2, "0")}`;
  };

  function removePaddedZeros(str) {
    return str.replace(/^0+/, ""); // Replace one or more zeros at the beginning of the string with an empty string
  }

  return (
    <>
      <Container maxWidth="xl" sx={{ mt: 8, px: 1 }} disableGutters>
        <Grid container spacing={1} sx={{ pl: 3, pr: 3 }} display="flex">
          <Grid item xs={12} md={4} textAlign="left" alignSelf={"center"}>
            <div className="pageHeader">
              Upcoming Appointments {totalElement > 0 && `(${totalElement})`}
            </div>
          </Grid>
          <Grid item xs={12} md={8} textAlign={"right"}>
            <SmartSearch
              isSearchMode={isSearchMode}
              options={[
                { id: "PO", label: "Search By PO Number" },
                { id: "Appointment Id", label: "Search By Appointment Id" },
              ]}
              onActionClick={onClickSearch}
              onCancelClick={async () => {
                setIsSearchMode(false);
                await handleTableChanges({ pageNo: 0, pageSize: 10 }, false);
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={12} mb={5} sx={{ pl: 3, pr: 3, mt: 2 }}>
            {searchedRows?.length > 0 ? (
              <Paper elevation={3} variant="elevation">
                <TableContainer sx={{ maxHeight: 720 }} className="tableScroll">
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow key={"1"}>
                        {APPOINTMENT_DETAILS_LISTING_COLUMNS.map((column) => (
                          <TableCell
                            className="tableHeader"
                            size="small"
                            variant="head"
                            key={column.id}
                            sx={{ pt: 1.5, pb: 1.5, fontSize: "13px" }}
                          >
                            {column.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>

                    <TableBody sx={{ mt: 2 }}>
                      {searchedRows
                        .slice(pageNo * pageSize, pageNo * pageSize + pageSize)
                        .map((row, index) => {
                          return (
                            <TableRow hover tabIndex={-1} key={index}>
                              <TableCell
                                size="small"
                                sx={{
                                  pt: 1.5,
                                  pb: 1.5,
                                  fontSize: "12px",
                                }}
                                key={"appointmentId"}
                              >
                                {row["appointmentId"] ?? "-"}
                              </TableCell>
                             
                              <TableCell
                                size="small"
                                sx={{
                                  pt: 1.5,
                                  pb: 1.5,
                                  fontSize: "12px",
                                }}
                                key={"appointmentDate"}
                              >
                                {convertDateFromUTCString(
                                  row["appointmentDate"]
                                ) ?? "-"}
                              </TableCell>
                              <TableCell
                                size="small"
                                sx={{
                                  pt: 1.5,
                                  pb: 1.5,
                                  fontSize: "12px",
                                }}
                                key={"appointmentStartTime"}
                              >
                                {formatTime(row["appointmentStartTime"]) ?? "-"}
                              </TableCell>
                              <TableCell
                                size="small"
                                sx={{
                                  pt: 1.5,
                                  pb: 1.5,
                                  fontSize: "12px",
                                }}
                                key={"vendorCode"}
                              >
                                {removePaddedZeros(row["vendorCode"]) ?? "-"}
                              </TableCell>
                              <TableCell
                                size="small"
                                sx={{
                                  pt: 1.5,
                                  pb: 1.5,
                                  fontSize: "12px",
                                }}
                                key={"fcCode"}
                              >
                                {row["fcCode"] ?? "-"} <br></br>{row["fcName"] ?? "-"}
                              </TableCell>
                              <TableCell
                                size="small"
                                sx={{
                                  pt: 1.5,
                                  pb: 1.5,
                                  fontSize: "12px",
                                }}
                                key={"dockName"}
                              >
                                {row["dockName"] ?? "-"}
                              </TableCell>
                              {/* <TableCell
                                size="small"
                                sx={{
                                  pt: 1.5,
                                  pb: 1.5,
                                  fontSize: "12px",
                                }}
                                key={"fcName"}
                              >
                                {row["fcName"] ?? "-"}
                              </TableCell> */}
                              <TableCell
                                size="small"
                                sx={{
                                  pt: 1.5,
                                  pb: 1.5,
                                  fontSize: "12px",
                                }}
                                key={"poNumber"}
                              >
                                {row["poParams"]?.map((item) => (
                                  <Box
                                    display="flex"
                                    alignItems={"center"}
                                    key={item.poNumber}
                                  >
                                    <List fontSize={"small"} />
                                    <Typography variant="body2" ml={1}>
                                      {removePaddedZeros(item.poNumber)} ({item.noOfCases})
                                    </Typography>
                                  </Box>
                                )) ?? "-"}
                              </TableCell>

                              <TableCell
                                size="small"
                                sx={{
                                  color: getStatusColor(row["status"]),
                                  pt: 1.5,
                                  pb: 1.5,
                                  fontSize: "12px",
                                  fontWeight: 700,
                                }}
                                key={"status"}
                              >
                                {row["statusContent"]}
                              </TableCell>
                              <TableCell
                                size="small"
                                sx={{
                                  color: "#8b8a8a",
                                  pt: 1.5,
                                  pb: 1.5,
                                  fontSize: "12px",
                                }}
                                key={"details"}
                              >
                                <ButtonGroup
                                  variant="none"
                                  aria-label="Basic button group"
                                >
                                  <Action
                                    onClickPreview={() => {
                                      handleClickOpen(row);
                                    }}
                                    onClickEdit={() => {
                                      onclickEdit(row);
                                    }}
                                    onClickCancel={() => {
                                      cancelAppoitmentPopup(row);
                                    }}
                                    status={row["status"]}
                                    isEditFlag={isEditAllowed(
                                      row?.appointmentDate
                                    )}
                                    isCancelFlag={isCancelAllowed(
                                      row?.appointmentDate
                                    )}
                                    userId={row?.userId}
                                  />
                                </ButtonGroup>
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25, 100]}
                  component="div"
                  count={totalElement}
                  rowsPerPage={pageSize}
                  page={pageNo}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
            ) : (
              <Paper elevation={3} variant="elevation">
                <NoDataComponent />
              </Paper>
            )}
            {dialogOpen && (
              <AppoinmentDetailPopUp
                dialogOpen={dialogOpen}
                handleClose={handleClose}
                appointmentDetails={appointmentDetails}
                convertDate={convertDateFromUTCString}
              />
            )}
            <CancelAppointmentPopup
              cancelAppointment={cancelAppointment}
              dialogOpen={cancel}
              handleClose={() => setCancel(false)}
              onClickYes={cancelAppoitment}
            />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};
export default AppointmentListing;
